<app-partner-select-header></app-partner-select-header>
<router-outlet></router-outlet>
<!-- <app-partner-management *ngIf="showPartnersMgmt"></app-partner-management>
<app-partner-group-management *ngIf="showPartnerGroupsMgmt"></app-partner-group-management> -->